import { render, staticRenderFns } from "./TaskProgressBar.vue?vue&type=template&id=5dbf0f18&scoped=true&"
import script from "./TaskProgressBar.vue?vue&type=script&lang=js&"
export * from "./TaskProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./TaskProgressBar.vue?vue&type=style&index=0&id=5dbf0f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf0f18",
  null
  
)

export default component.exports